import { generatePath, useParams } from 'react-router-dom';

import { GameStatus } from '@sorare/core/src/__generated__/globalTypes';
import LoadingIndicator from '@sorare/core/src/atoms/loader/LoadingIndicator';
import {
  FOOTBALL_PLAY_RIVALS_MATCHES,
  FOOTBALL_PLAY_RIVALS_MATCHES_DATE_SLUG_OVERVIEW,
} from '@sorare/core/src/constants/__generated__/routes';
import { Navigate } from '@sorare/core/src/routing/Navigate';

import {
  isGameFinished,
  isGameLive,
  isGameScheduled,
} from '@sorare/gameplay/src/lib/so5';

import { Lineups } from 'components/rivals/matches/Lineups';
import { useFetchGameStatus } from 'pages/play/rivals/matches/:date/:slug/useFetchGameStatus';

const RivalsLiveLineupsPage = () => {
  const { slug = '', date = '' } = useParams();

  const { loading, status } = useFetchGameStatus(slug);

  if (loading && !status) {
    return <LoadingIndicator />;
  }

  if (isGameLive(status) || isGameFinished(status || GameStatus.played)) {
    return <Lineups rivalsGameSlug={slug} />;
  }

  if (isGameScheduled(status)) {
    return (
      <Navigate
        keepSearchParams
        replace
        to={generatePath(FOOTBALL_PLAY_RIVALS_MATCHES_DATE_SLUG_OVERVIEW, {
          date,
          slug,
        })}
      />
    );
  }

  return (
    <Navigate keepSearchParams replace to={FOOTBALL_PLAY_RIVALS_MATCHES} />
  );
};

export default RivalsLiveLineupsPage;
